// mixin.js
import Vue from 'vue';
import Component from 'vue-class-component';

// You can declare a mixin as the same style as components.
@Component
export default class MobileDetectionMixin extends Vue {
  public isMobile = false;

  public mounted() {
    this.onResize();
    window.addEventListener('resize', this.onResize, { passive: true });
  }

  public beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize);
    }
  }

  public onResize() {
    this.isMobile = window.innerWidth < 600;
  }
}
